import { ReactNode, useId } from 'react';

import InputError from './InputError';

import { cn } from '@/utils';

interface InputCheckboxProps {
  label: string | ReactNode;
  isChecked: boolean;
  onChange: (name: string, isChecked: boolean) => void;
  className?: string;
  name: string;
  error?: string;
  disabled?: boolean;
}

const InputCheckbox = ({
  label,
  isChecked,
  className,
  name,
  error,
  onChange,
  disabled,
}: InputCheckboxProps) => {
  const id = useId();
  const nameId = `${name}-${id}`;

  const labelClass = cn(
    'text-sm font-semibold text-gdt-gray-3 select-none relative flex items-center gap-1 cursor-pointer',
    className
  );

  return (
    <div className="space-y-1">
      <div className="flex items-center space-x-3">
        <button
          aria-checked={isChecked ? 'true' : 'false'}
          className={cn(
            'peer check-boxs-shadow h-[19px] w-[19px] shrink-0 rounded-[5px] border-[1.5px] border-gdt-gray-4 flex items-center justify-center bg-gray-7',
            {
              'border-gdt-blue bg-gdt-blue-xl2': isChecked,
            }
          )}
          disabled={disabled}
          id={nameId}
          role="checkbox"
          type="button"
          onClick={() => onChange(name, !isChecked)}
        >
          {isChecked && (
            <svg
              fill="none"
              height="8"
              viewBox="0 0 10 8"
              width="10"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.87116 3.91922C1.71697 3.78802 1.51604 3.71683 1.30869 3.71994C1.10133 3.72305 0.902888 3.80022 0.753162 3.93597C0.603436 4.07173 0.513503 4.25602 0.501401 4.45189C0.4893 4.64776 0.555925 4.84071 0.687913 4.99205L2.51209 6.80342C2.58846 6.87922 2.68024 6.93964 2.7819 6.98105C2.88357 7.02247 2.99303 7.04402 3.10372 7.04442C3.21382 7.04503 3.32292 7.0247 3.42455 6.98463C3.52619 6.94457 3.61827 6.88559 3.69534 6.8112L9.26648 1.3693C9.34201 1.29579 9.40151 1.20893 9.44156 1.11367C9.48161 1.01841 9.50144 0.916621 9.49992 0.814112C9.49839 0.711603 9.47554 0.610382 9.43267 0.516228C9.38979 0.422074 9.32774 0.336832 9.25005 0.265368C9.17235 0.193904 9.08054 0.137618 8.97986 0.0997231C8.87917 0.0618284 8.77158 0.0430672 8.66323 0.044511C8.55488 0.0459548 8.4479 0.0675751 8.34838 0.108138C8.24886 0.1487 8.15876 0.207411 8.08323 0.280916L3.11193 5.14753L1.87116 3.91922Z"
                fill="#3366FF"
              />
            </svg>
          )}
        </button>
        <label className={labelClass} htmlFor={nameId}>
          {label}
        </label>
      </div>
      {error && <InputError.Label>{error}</InputError.Label>}
    </div>
  );
};

export default InputCheckbox;
